
import coca from '../src/img/coca.png'
import coxinha from '../src/img/coxinha.png'
import arroz from '../src/img/arroz.png'
import pizza from '../src/img/pizza.png'
import file from '../src/img/file.png'
import peixe from '../src/img/peixe.png'
import gas from '../src/img/gas.png'
import queijo from '../src/img/queijo.png'


export const listaProdutos = [
    {
        nome: 'coca-cola',
        preco: 4.50,
        img: coca
    },
    {
        nome: 'Coxinha',
        preco: 6.50,
        img: coxinha
    },
    {
        nome: 'Arroz',
        preco: 3.50,
        img: arroz
    },
    {
        nome: 'Pizza',
        preco: 11.50,
        img: pizza
    },

    {
        nome: 'Filé de carne 1kg',
        preco: 28.50,
        img: file
    },
    {
        nome: 'Filé de peixe 1kg',
        preco: 17.50,
        img: peixe
    },

    {
        nome: ' Gás de cozinha',
        preco: 92.00,
        img: gas
    },

    {
        nome: ' Queijo 1kg',
        preco: 19.79,
        img: queijo
    },



]